import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SignInButton } from "src/components/SignInButton";
import TermsAndConditions from "src/components/TermsAndConditions";
import { MessageBar, MessageBarType } from "@fluentui/react";
import style from "./index.module.scss";

const Login = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const from = location.state?.from || "/";
    const [termsAccepted, setTermsAccepted] = useState(true);
    const [showError, setShowError] = useState(false);

    const handleSignInAttempt = () => {
        if (!termsAccepted) {
            setShowError(true);
            return;
        }
        setShowError(false);
        navigate(from);
    };

    return (
        <div className={style.login}>
            <h1>Sign in with your Microsoft account</h1>

            {showError && (
                <MessageBar
                    messageBarType={MessageBarType.error}
                    onDismiss={() => setShowError(false)}
                >
                    Please accept the Terms and Conditions to continue.
                </MessageBar>
            )}

            <TermsAndConditions
                isAccepted={termsAccepted}
                onAcceptChange={setTermsAccepted}
            />

            <SignInButton
                onSuccess={handleSignInAttempt}
                disabled={!termsAccepted}
            />
        </div>
    );
};

export default Login;
